import React, { SVGProps } from "react"

import { IconName } from "hived-theme/lib/iconList"

import { cn } from "@/lib/utils"

import iconList from "./iconList"

interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName
  containerClasses?: string
  onClick?: () => void
}

const Icon = ({ className, name, ...props }: IconProps) => {
  const SVGComponent = iconList[name]
  return (
    <SVGComponent
      data-testid={`${name}-icon`}
      title={name}
      className={cn("text-palette-jungleGreen900", className)}
      {...props}
    />
  )
}

export default Icon
